import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { setFormFieldValue } from '@app/components/form/services/schema-form/schema-form-functions';
import { EntityId, IBaseEntityType, ISite } from '@app/shared/types';
import { find, get, isEmpty } from 'lodash';
import { DataSource } from '../datasource';

@Injectable()
export class AutoPopulateService {
  public populateCommonSynchroField(
    form: FormGroup,
    fieldPath: string,
    baseOnData: IBaseEntityType,
  ): void {
    const fieldValue = get(baseOnData, fieldPath);

    if (!isEmpty(fieldValue)) {
      setFormFieldValue(form, fieldPath, fieldValue, false);
    }
  }

  public async populateAsynchronousEvent(
    form: FormGroup,
    fieldPath: string,
    transferEventId: EntityId,
    eventIdDataSource: DataSource,
  ): Promise<void> {
    if (isEmpty(transferEventId)) {
      return;
    }

    const events = await eventIdDataSource.nextPage();
    const transferEvent = find(events, { id: transferEventId });

    if (isEmpty(transferEvent)) {
      return;
    }

    setFormFieldValue(form, fieldPath, transferEventId, false);
  }

  public async populateAsynchronousSite(
    form: FormGroup,
    fieldPath: string,
    siteId: EntityId,
    siteList: ISite[],
  ): Promise<void> {
    if (isEmpty(siteId)) {
      return;
    }

    const autoPopulateSite = find(siteList, { id: siteId });

    if (isEmpty(autoPopulateSite)) {
      return;
    }
    setFormFieldValue(form, fieldPath, siteId, false);
  }
}
